export default __webpack_public_path__ + "static/media/ollantaytambo-alley.de71f8e4.jpg";